import { render } from "./InfoTip.vue?vue&type=template&id=7540ac12&ts=true"
import script from "./InfoTip.vue?vue&type=script&lang=ts"
export * from "./InfoTip.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__